function change_product_wrapper(index,obj){
  let w = (index - 1) * obj.offsetWidth;
  let elements = obj.parentNode.querySelectorAll(".change-link");
  let elements_2 = obj.parentNode.parentNode.querySelectorAll(".product-wrapper")
  for (i = 0; i < elements.length; i++) {
     elements[i].classList.remove('active');
     elements_2[i].classList.remove('active');
     elements_2[i].classList.remove('opacity');
  }
  obj.classList.add('active');
  obj.parentNode.parentNode.querySelector(`.product-wrapper-${index}`).classList.add('active');
  obj.parentNode.querySelector(".change-link-wrapper-after").style.left = `${w}px`;
  setTimeout(function(){ 
   obj.parentNode.parentNode.querySelector(`.product-wrapper-${index}`).classList.add('opacity');
  },10)
}

function header__search_mb(){
  document.getElementById('Details-menu-drawer-container').querySelector("summary").click()
}